import React from "react";
import { useRouteError } from "react-router-dom";
import { ErrorContainer } from "./Error.styles";

const ErrorScreen = () => {
  const error: any = useRouteError();
  console.log("error", error);

  return (
    <ErrorContainer>
      <h1>Oops!</h1>
      <p>an unexpected Error occured.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </ErrorContainer>
  );
};

export default ErrorScreen;
